<template>
  <th v-if="is_header()" class="chart-data heading">
    <slot></slot>
  </th>
  <td v-else class="chart-data">
    <slot></slot>
  </td>
</template>

<script>
export default {
  name: 'chart-data',
  methods: {
    is_header () {
      return this.$parent.$parent.$options._componentTag === 'chart-header'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.chart-data {
  border-collapse: collapse;
  border: 1px solid $secondary;
  text-align: center;
  vertical-align: middle;
  word-wrap: break-word;
  @include mq-down(md){
    font-size: 12px;
    padding: 15px 5px;
    &.-low {
      padding-top: 8px;
      padding-bottom: 8px;
    }
    .-sp-left & {
      text-align: left;
    }
    .-sp-right & {
      text-align: right;
    }
    &.-sp-left {
      text-align: left !important;
    }
    &.-sp-right {
      text-align: right !important;
    }
    &.-sp-center {
      text-align: center !important;
    }
  }
  @include mq-up(md) {
    padding: 20px;
    &.-low {
      padding-top: 15px;
      padding-bottom: 15px;
    }
    .-pc-left & {
      text-align: left;
    }
    .-pc-right & {
      text-align: right;
    }
    &.-pc-left {
      text-align: left !important;
    }
    &.-pc-right {
      text-align: right !important;
    }
    &.-pc-center {
      text-align: center !important;
    }
  }
  &.-disbursal,
  &.-orange {
    background-color: $success;
  }
  &.-payment,
  &.-green {
    background-color: $twilight;
  }
  &.-sm {
    width: 16.6%;
    @include mq-down(md){
      width: 13%;
    }
  }
  @for $i from 1 through 10 {
    &.-justify-#{$i} {
      width: percentage((1 - 0.166) / $i);
      @include mq-down(md){
        width: percentage((1 - 0.13) / $i);
      }
    }
  }
  @for $i from 1 through 100 {
    @include mq-up(md){
      &.-pcfix-#{$i} {
        width: percentage($i * 0.01);
      }
    }
  }
  @for $i from 1 through 100 {
    @include mq-down(md){
      &.-spfix-#{$i} {
        width: percentage($i * 0.01);
      }
    }
  }
  &.heading {
    background-color: $light;
    font-weight: normal;
  }
  &.-blank {
    border: none;
  }
  .-dark & {
    background-color: $medium;
  }
  .chart-group.toggle .chart-box.-hide & {
    transition: border 300ms ease;
    transition-delay: 300ms;
    border-top: 1px solid $secondary;
  }
  .chart-group.toggle.open .chart-box.-hide & {
    border-top: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/charts/ChartData.vue